import React from 'react';
import t from '~t';
import { useSelector, useDispatch } from 'react-redux';
import { setAppSize } from '~local/actions';

import { Label, Checkbox } from '~ui';

export default function SettingsAppSize() {
  const appSize = useSelector((state) => state.local.appSize);
  const dispatch = useDispatch();

  return (
    <>
      <Label>{t.s('fontSize')}</Label>
      <div>
        <Checkbox
          checked={appSize == 'large'}
          onChange={() =>
            dispatch(setAppSize(appSize == 'large' ? '' : 'large'))
          }
        >
          {t.s('large')}
        </Checkbox>
      </div>
    </>
  );
}
